module.exports = __webpack_public_path__ + "img/link-icon.baf1fe46.svg";